<template>
    <div class="basket-wrapper">
        <div class="basket" :class="{'basket-empty': isBasketEmpty()}">
          <BasketHeader></BasketHeader>

          <BasketBody></BasketBody>

          <BasketListFooter v-if="isBasketEmpty()"></BasketListFooter>
        </div>
    </div>
</template>

<script>
    import BasketUtils from "./basket/BasketUtils";
    import BasketListFooter from "./basket/BasketListFooter";
    import Utils from "./Utils";
    import {mask} from 'vue-the-mask';
    import BasketHeader from "./basket/BasketHeader";
    import BasketBody from "./basket/BasketBody";

    export default {
        name: "Basket",
        data: function(){
            return {
                deferOrderTime: null,
                pizzeriaID: 1,
                deferInputHover: false,
                deferInputError: false,
                deliveryAddress: {
                    street: null,
                    house: null,
                    entrance: null,
                    floor: null,
                    flat: null,
                    doorphone: null,
                },
                error: null,
                streets: [],
            };
        },
        components: {
          BasketHeader,
          BasketBody,
          BasketListFooter
        },
        mounted(){
            this.addFixedBodyClass(true);
            this.calculateDiscount();
        },
        destroyed() {
            this.addFixedBodyClass(false);
        },
        directives: {mask},
        mixins: [Utils, BasketUtils],
    }
</script>

<style>

</style>
